export default __webpack_public_path__ + "static/media/scrollbar_decrement.388e9a7c.svg";